module.exports = __webpack_public_path__ + "static/img/color.f35f8992.jpg";